import { render, staticRenderFns } from "./index.vue?vue&type=template&id=542831b6&scoped=true"
import script from "./composition.js?vue&type=script&lang=js&external"
export * from "./composition.js?vue&type=script&lang=js&external"
import style0 from "./styles.scss?vue&type=style&index=0&id=542831b6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542831b6",
  null
  
)

export default component.exports